import React, { useMemo } from 'react';
import { EMediaType } from '@umu/umu-types';
import { FileSelect, IEndData } from '../../../fileSelect/fileSelect';
export type { IEndData } from '../../../fileSelect/fileSelect';

interface IProps {
    multiple: boolean;
    disabled: boolean;
    teacherId: string;
    onlyPreview?: boolean;
    onClick?: (e: React.MouseEvent) => void;
    fileSelectedCallback: () => void;
    onEnd: (data: IEndData[]) => void;
    onUploadError: (e: Error) => void;
    onData?: (url: string, fileName: string, resourceId: string) => void;
    onPreview?: (objectUrl: string, file: File) => void;
    onSelectReady?: (files: Array<{ file: File; previewUrl: string }>) => void;
    buttonClass: string;
    children?: React.ReactNode;
}

export function PhotoBrowserUploader(props: IProps) {
    const controller = useMemo(
        () => ({
            onData: (_previewUrl: string, url: string, fileName: string, resourceId: string) => {
                props.onData && props.onData(url, fileName, resourceId);
            },
            onStart: props.fileSelectedCallback,
            onEnd: props.onEnd,
            onUploadError: props.onUploadError,
            onPreview: props.onPreview,
            onSelectReady: props.onSelectReady,
        }),
        [],
    );

    const onClick = (e: React.MouseEvent) => {
        if (props.onClick) {
            props.onClick(e);
        }
    };

    return (
        <div className="photo-browser-uploader" onClick={onClick}>
            <FileSelect
                disabled={props.disabled}
                multiple={props.multiple}
                onlyPreview={props.onlyPreview}
                mediaType={EMediaType.PIC_WEIKE}
                teacherId={props.teacherId}
                className={props.buttonClass}
                onUploadError={controller.onUploadError}
                onData={controller.onData}
                onEnd={controller.onEnd}
                onStart={controller.onStart}
                onPreview={controller.onPreview}
                onSelectReady={controller.onSelectReady}
            >
                {props.children}
            </FileSelect>
        </div>
    );
}
